import { render, staticRenderFns } from "./PermissionPage.vue?vue&type=template&id=94cbf894&scoped=true"
import script from "./PermissionPage.vue?vue&type=script&lang=js"
export * from "./PermissionPage.vue?vue&type=script&lang=js"
import style0 from "./PermissionPage.vue?vue&type=style&index=0&id=94cbf894&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cbf894",
  null
  
)

export default component.exports